import type { PrivyClientConfig, WalletListEntry } from '@privy-io/react-auth';
import { baseSepolia, base } from 'wagmi/chains';
import { env } from './utils/envs';

const walletList: WalletListEntry[] = [
  'detected_ethereum_wallets',
  'metamask',
  'coinbase_wallet',
  'wallet_connect',
  'wallet_connect_qr',
];

export const privyConfig: PrivyClientConfig = {
  loginMethods: ['wallet'],
  appearance: {
    theme: 'dark',
    accentColor: '#FE6162',
    logo: '/logo-white.png',
    walletList,
    walletChainType: 'ethereum-only',
    showWalletLoginFirst: true,
    landingHeader: 'Connect your wallet',
  },
  supportedChains: env.VITE_TESTNET ? [baseSepolia] : [base],
  walletConnectCloudProjectId: env.VITE_WALLET_CONNECT_PROJECT_ID,
  embeddedWallets: {
    ethereum: {
      createOnLogin: 'off',
    },
    solana: {
      createOnLogin: 'off',
    },
    showWalletUIs: true,
  },
};

export const privyAppId = env.VITE_PRIVY_APP_ID;
